import React from 'react';
import { heroStats } from '../data/content';
export function StatsBar() {
  return <section aria-label="Key figures" className="border-b border-line bg-panel" data-id="element-232" data-mp="1tarladr61yn0">
      <dl className="mx-auto grid max-w-7xl grid-cols-2 gap-px bg-line lg:grid-cols-4" data-id="element-233" data-mp="1ob58u6j5wmf9">
        {heroStats.map(stat => <div key={stat.value} className="bg-panel px-5 py-8 sm:px-8" data-id="element-234" data-mp="1jb92w1qwmkx2">
            <dt className="sr-only" data-id="element-235" data-mp="1ecz8htd07oci">{stat.label}</dt>
            <dd data-id="element-236" data-mp="1eein7fj0hrc6">
              <span className="block font-display text-4xl font-extrabold leading-none text-acid sm:text-5xl" data-id="element-237" data-mp="1efbuchlvuiuu">
                {stat.value}
              </span>
              <span className="mt-2 block text-xs leading-snug text-white/50 sm:text-sm" data-id="element-238" data-mp="15lp5lbg3efv5">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}